import styled from 'styled-components'

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 4px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #757575;
`

export const RequiredMark = styled.span`
  margin-left: 4px;
  color: #f5222d;
  font-weight: 700;
  line-height: 18px;
`
